package one.healthium.tasks.data.storages

import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.json.Json
import one.healthium.base.coroutines.IO
import one.healthium.tasks.data.dto.DailyTasksDto
import one.healthium.tasks.data.mapper.DailyTaskMapper
import one.healthium.tasks.domain.DailyTaskInfoModel
import one.healthium.locale.LocaleProvider
import one.primehealth.app.BaseAppResourceProvider

internal class TasksInfoStorage(
    private val json: Json,
    private val dailyTaskMapper: DailyTaskMapper,
    private val appResourceProvider: BaseAppResourceProvider,
    private val localeProvider: LocaleProvider,
) {

    suspend fun getTasksInfo(): List<List<DailyTaskInfoModel>> {
        return withContext(Dispatchers.IO) {
            val locale = localeProvider.getLocale()
            val bytes = appResourceProvider.readBytes("files/daily_tasks/$locale/daily_tasks_v1.json")
            val dailyTasksDto = json.decodeFromString<DailyTasksDto>(bytes.decodeToString())
            dailyTaskMapper.dtoToModel(dailyTasksDto)
        }
    }
}